// typings

import { create } from "zustand";

import { ITecnologiasState } from "@/store-zustand/tecnologias/index.d";

// criação da store com Zustand (tecnologias)
export const useStoreZustandTecnologias = create<ITecnologiasState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  downloadLoad: [],
  minhasTarefas: [],
  tecnologias: [1],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setTecnoligias: (tecnologias) => set({ tecnologias }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
}));
